import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.11.2_@types+node@20.2.4_@unocss+reset@0.59.4_axios@1.4.0_eslint@8.41.0_floating-vue@5._ilrzprycdi33lgvqv64su5jo2i/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}